import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain headings preserve
// legacy className behavior across existing screens.
const Heading1 = ({
  id, children, className, tokens, variant, align
}) => {
  if (!tokens) {
    return (
      <h1 className={`text-2xl leading-none text-h1 font-h1 ${className || ''}`} id={id}>
        {children}
      </h1>
    )
  }

  return (
    <div className={className} id={id}>
      <Typography block heading="h1" align={align} variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </div>
  )
}

Heading1.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({}),
  align: PropTypes.string
}

Heading1.defaultProps = {
  variant: { size: 'h1' }
}

export default Heading1
